import type { IController, IScope } from 'angular';
import type { ILoginController } from './login.controller';
export interface ILoginModuleController extends IController {
  id?: string;
  controllerName?: string;
  showRoutes: boolean;
  src: string;
  redirectTo?: string;
  parentCtrl?: ILoginController;
  initSrc(): void;
}
export default class LoginModuleController implements ILoginModuleController {
  id?: string;
  controllerName?: string;
  showRoutes = true;
  src = '';
  redirectTo?: string;
  parentCtrl?: ILoginController;

  /* @ngInject */
  constructor(readonly $scope: IScope) {}
  $onInit() {
    this.initSrc();
    this.changeShowRoutes(this.showRoutes);
    this.$scope.$on('$includeContentLoaded', () => {
      this.setLoaded(false);
    });
  }
  initSrc() {
    const query = this.redirectTo != null ? `?redirectTo=${encodeURIComponent(this.redirectTo)}` : '';
    this.src = `module/${this.controllerName}/login${query}`;
  }
  setLoaded(loaded: boolean) {
    if (typeof this.parentCtrl !== 'undefined' && this.parentCtrl !== null) {
      this.parentCtrl.loaded = loaded;
    }
  }
  changeShowRoutes(show: boolean) {
    if (typeof this.parentCtrl !== 'undefined' && this.parentCtrl !== null) {
      this.parentCtrl.showAuthMethods = show;
    }
  }
}
LoginModuleController.$inject = ["$scope"];